<div>
<input class="hand"
 type="radio"
 [id]="id"
 [name]="name"
 [value]="status"
 [checked]="status"
 [required]="required"
 [disabled]="disabled"
 (change)="check.emit($event.target.checked)" 
/>
<label  [ngClass]="labelClass" [for]="id" class="mb-0 secondary-text hand text-light-gray"> {{ lableName }}</label>
</div>
